import { AccessClient } from "./axiosInstance.js";

// 모든 주차 가져오기
export const loadAllWeeks = async () => {
  try {
    const response = await AccessClient.get("/api/weeks");
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    //console.log(status);
    //console.log(message);
    return { status, message };
  }
};

// 특정 주차 가져오기
export const loadWeek = async ({ id }) => {
  try {
    const response = await AccessClient.get(`/api/weeks/${id}`);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    //console.log(status);
    //console.log(message);

    return { status, message };
  }
};

// 특정 주차 저장하기
export const saveWeek = async ({ id, week, state, auth, teams }) => {
  try {
    const response = await AccessClient.put(`/api/weeks/${id}`, {
      week,
      state,
      auth,
      teams,
    });
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};
